import { trpc } from "@api/client";

export const useGetAvailableQuestions = (companyId: string) => {
  const { data, error, isLoading, isInitialLoading } =
    trpc.getAvailableQuestions.useQuery(
      { companyId },
      { enabled: !!companyId, retry: false, refetchOnWindowFocus: false }
    );
  return { questions: data, error, isLoading, isInitialLoading };
};
